export enum UserRoles {
  GUEST = "GUEST",
  COWORKER = "COWORKER",
  STOREOWNER = "STOREOWNER",
  COUNTRY_SUPERUSER = "COUNTRY_SUPERUSER",
  SUPERUSER = "SUPERUSER",
}
